module.exports = __webpack_public_path__ + "svg/mygreen-dark.svg?e7069f7dfdfe1eb313866d63266a5ff2";